
import { Component, Vue, Prop } from 'vue-property-decorator';
import ErrorAlert from 'spa-ionata-admin/lib/components/ErrorAlert.vue';
import ObservedPromise from 'spa-ionata-admin/lib/services/ObservedPromise';
import Post from '../models/Post';
import TitledSection from './TitledSection.vue';

@Component({ components: { TitledSection, ErrorAlert } })
export default class PostLanding extends Vue {
  @Prop(String) readonly slug!: string;

  @Prop(Object) readonly post!: Post;

  @Prop([Number, String]) readonly mdCols!: number | string;

  @Prop({ type: Boolean, default: false }) readonly bordered!: boolean;

  @Prop(String) readonly to!: string;

  @Prop(Boolean) readonly noButton!: boolean;

  @Prop(Boolean) readonly fillHeight!: boolean;

  @Prop({ type: Boolean, default: null }) readonly dark!: boolean;

  @Prop({ type: Boolean, default: null }) readonly light!: boolean;

  get fetcher() {
    const { slug } = this;
    const promise = Post.where({ slug }).first();
    return new ObservedPromise(promise);
  }

  get thePost(): Post | undefined {
    return this.post || this.fetcher.value?.data || undefined;
  }

  get error() {
    if (this.fetcher.isError) {
      return this.fetcher.error;
    }
    if (this.fetcher.isFinished && !this.thePost) {
      let { slug } = this;
      if (!slug) {
        slug = '[blank]';
      }
      const maxLength = 50;
      if (slug.length > maxLength) {
        slug = `${slug.substring(0, maxLength)}…`;
      }
      return new Error(`Post '${slug}' not found.`);
    }
    return undefined;
  }

  get isDark() {
    return this.thePost?.isDark;
  }

  get isLight() {
    return !this.isDark;
  }
}
